import { Logo as ComponentLogo } from '@a0/docs-components/ui/Header/Logo';
import { NavLink } from 'fluxible-router';
import * as React from 'react';
export var Logo = function (props) { return (React.createElement(NavLink, { href: props === null || props === void 0 ? void 0 : props.href },
    React.createElement(ComponentLogo, null))); };
